/**
 * Yioak brand config
 */
export default {
  id: 'yioak',
  name: 'Yioak',
  title: 'Data',
  companyName: 'Yioak Information Technology (Hongkong) Co., Limited',
  companyNameZh: '億橡信息科技（香港）有限公司',
  companyAddress:
    'Unit 08, 15/F, Witty Commercial Building, 1A-1L Tung Choi Street, Kowloon, Hong Kong.',
  companyRegNo: '3129940',
  companyType: '私人股份有限公司',
  companyStatus: '仍登記在冊',
  phone: '+86 0512-67678962',
  email: 'fish.xu@franwell.com',
  supportEmail: 'wujie@franwell.com',
  websiteHost: 'm.yioak.com',
  founded: '2022年02月23日',
  copyrightYear: '2025',
  logoFile: 'logo.png',
  favicon: 'favicon.ico',
  theme: {
    primary: '#FF4749',
    primaryStart: '#FF5E7C',
    primaryEnd: '#FF4749',
    primaryDisabledStart: '#FF9AAD',
    primaryDisabledEnd: '#FF8A8B',
    gradient: 'linear-gradient(90deg, #FF5E7C 0%, #FF4749 100%)',
    gradientH: 'linear-gradient(90deg, #FF5E7C 0%, #FF4749 100%)',
    pageBg: '#f5f5f5',
    bodyBg: '#f6f6f6',
  },
};
